import sortList from "../../../../services/OrderListService";

export default {
    documentAuthorities: state => sortList.orderListByUppercase(state.documentAuthorities, 'name')
}
